import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ExamService } from 'src/app/services/exam.service';
import { AudioService } from 'src/app/services/audio.service';
import { TranslationService } from 'src/app/services/translation.service';
import { FormsSetupService } from 'src/app/services/forms-setup.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop,CdkDrag, CdkDropList, CdkDropListGroup, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { config } from 'src/app/config/config';

@Component({
  selector: 'app-start-exam',
  imports: [CommonModule, FormsModule,DragDropModule,CdkDropListGroup, CdkDropList, CdkDrag],
  templateUrl: './start-exam.component.html',
  styleUrls: ['./start-exam.component.css']
})
export class StartExamComponent {


  isExamCompleted: boolean = false;
  ExamAttendanceNo: any;
  traineeName: any
  IDNumber: any
  LanguageID: number = 0;
  FormNumber: any;
  AttemptID: number = 0;
  ExamID: number = 0;
  bookingID: number = 0;
  selectedFolderName: string = '';
  
  languagesList: any[] = [];
  filteredLanguagesList: any[] = [];
  totalQuestions: number = 0;
  FormQuestions: any[] = [];

  QuestionContent: any;
  AnswersDto: any[] = [];
  currentQuestionText: string = '';
  selectedAnswer: any;
  selectedAnswers: any[] = [];  // Ordering and MulitAnswers questions type
  selectOrderAnswerID:number = 0;

  currentQuestionIndex: number = 0;
  progressPercentage: number = 0;
  remainingTime: number = 5400; // 1:30 hour
  remainingTimePerQuestion: number = 90; // 1:30 minute
  timerInterval: any;
  ServerTimeLocal: any;

  getImageLink: string = `${config.apiBaseUrl}/data/img/`;
  getVideoLink: string = `${config.apiBaseUrl}/data/vdo/`;

  skipCount: number = 3;
  isSkipped: boolean = false;
  postponeCount: number = 3;
  isPostponed: boolean = false;

  submitQustion: any = {}
  qusetionScore: number = 0;
  examStutus: any = {};
  skipThisQuestion: any = {};
  examResult: number = 0;
  
  isRTL: boolean = false;
  private currentAudio: HTMLAudioElement | null = null;
  private isPlaying = false;

  constructor(
    private router: Router,
    private audioService: AudioService,
    private examService: ExamService,
    public translationService: TranslationService,
    private formSetup: FormsSetupService
  ) {}

  ngOnInit() {
    this.getExamAttendanceNo();
    this.getLanguages();    
  }

  getLanguages() {
    this.examService.getLanguageList().subscribe(
      (response) => {
        this.languagesList = response.result[0].map((language: { LanguageName: any; ShortName: any; LanguageID: any }) => ({
          LanguageID : language.LanguageID,
          LanguageName: language.LanguageName,
          ShortName: language.ShortName
        }));

        const desiredLanguages = ["Arabic", "English", "Urdu (Pakistan)", "Bengali (Bangladesh)" , "Hindi (India)" , "Nepali (Nepal)" , "Malayalam" , "Tamil (India)" , "Filipino" , "Indonesian (Indonesia)" , "Turkish (Turkey)"];
        this.filteredLanguagesList = this.languagesList.filter(lang => desiredLanguages.includes(lang.LanguageName));
      }
    );
  }

    getExamAttendanceNo() {
      if(this.examService.ExamAttendanceNo) {
        this.examService.getTraineeDetailsByExamAttendanceNo(this.examService.ExamAttendanceNo, this.examService.LanguageID).subscribe((response) => {
          if (response.success === true && response.result.length > 0) {
            this.selectedFolderName = response.result[0][0].CourseName;
            this.ExamAttendanceNo = response.result[0][0].ExamAttendanceNumber;
            this.traineeName = response.result[0][0].TraineeName;
            this.IDNumber = response.result[0][0].IDNumber;
            this.bookingID = response.result[0][0].BookingID;
            this.startTestExam();
          } else {
            this.router.navigate(['dashboard/exam']);
          }
        });


        this.examService.getExamByAttendanceNo(this.examService.ExamAttendanceNo).subscribe((response) => {
          this.FormNumber = response.result[0][0].FormNo;
          this.AttemptID = response.result[0][0].AttemptID;
          this.ExamID = response.result[0][0].ExamID;
          this.LanguageID = response.result[0][0].LangID;
        });


      } else {
        this.router.navigate(['dashboard/exam']);
      }
    }
  


    startTestExam() {
      this.examService.getExamStatus(this.ExamAttendanceNo).subscribe((statusResponse) => {

        const data = statusResponse.result[0];

        const skippedCount = data.filter((item: any) => item.IsSkipped).length;
        const postponedCount = data.filter((item: any) => item.IsPostponed).length;

        this.skipCount = this.skipCount - skippedCount;
        this.postponeCount = this.postponeCount - postponedCount;


        const answeredQuestionIds = statusResponse.result[0].map((item: any) => item.QuestionID);

        this.examService.getServerTimeLocal().subscribe((serverTimeResponse) => {
          this.ServerTimeLocal = serverTimeResponse.result[0][0].ServerTimeLocal;
        
          const responses = statusResponse?.result[0];
        
          if (responses && responses.length > 0) {
            const lastCreatedDate = responses[responses.length - 1].CreatedDate;
            const lastCreatedDateTime = new Date(lastCreatedDate).getTime();
            const serverTimeLocalTime = new Date(this.ServerTimeLocal).getTime();
            const timeDifference = serverTimeLocalTime - lastCreatedDateTime;
            const timeDifferenceInSeconds = Math.floor(timeDifference / 1000);
            this.remainingTime = 5400 - timeDifferenceInSeconds;
          } else {
            this.remainingTime = 5400;
          }
        });
         
        this.formSetup.getQuestionsByCourseAndForm(this.ExamID, this.FormNumber, this.LanguageID).subscribe((response) => {
          let allQuestions = response.result?.[0] || [];
    
          this.FormQuestions = allQuestions.filter((q: { QuestionID: any }) => !answeredQuestionIds.includes(q.QuestionID));
    
          this.FormQuestions = this.FormQuestions.sort(() => Math.random() - 0.5);

          if (this.FormQuestions.length > 0) {
            this.totalQuestions = this.FormQuestions.length;
            this.submitQustion = {};
            this.loadQuestion(0);
            this.startTimer();
          }
        });
    
        if (this.examService.LanguageID == 2) {
          this.isRTL = true;
        }
    
        this.LanguageID = this.examService.LanguageID;
      });
    }
    



  loadQuestion(index: number) {
    const currentQuestionData = this.FormQuestions[index];
    this.QuestionContent = { ...currentQuestionData }; 
    this.currentQuestionText = currentQuestionData.QuestionText;
    this.currentQuestionIndex = index; 
    this.progressPercentage = ((index + 1) / this.totalQuestions) * 100;
  
    if (this.QuestionContent.QuestionType !== 'Ordering') {
      this.formSetup.getAnswersByQuestionID(currentQuestionData.QuestionID).subscribe((response) => {
        this.AnswersDto = response.result[0];
        this.AnswersDto = this.AnswersDto.sort(() => Math.random() - 0.5);
      });


      if (this.QuestionContent.QuestionType === 'RightOrWrongVideo') {
        this.QuestionContent.VideoLink = currentQuestionData.VideoLink;
        this.remainingTimePerQuestion = 150; 
        this.remainingTime = this.remainingTime + 60;

        setTimeout(() => {
          const videoElement = document.getElementById('questionVideo') as HTMLVideoElement;
          if (videoElement) {
            videoElement.play();
          }
        }, 5000);
      }
  
      const videoElement = document.getElementById('questionVideo') as HTMLVideoElement;
      if (videoElement) {
        videoElement.pause();
        videoElement.load();
      }
  
      if (this.QuestionContent.QuestionType === 'MCQImage' || this.QuestionContent.QuestionType === 'RightOrWrongImage') {
        this.QuestionContent.ImageLink = currentQuestionData.ImageLink;
      }
    }
    

    if (this.QuestionContent.QuestionType === 'Ordering') {
      this.formSetup.getAnswersByQuestionID(currentQuestionData.QuestionID).subscribe((response) => {
        
        this.selectOrderAnswerID = response.result[0][0].AnswerID;
        const result = response.result[0];

        if (result.length === 1 && result[0].AnswerText.includes(',')) {
          const rawAnswers = result[0].AnswerText;
          this.AnswersDto = rawAnswers
            .split(',')
            .map((text: string, index: number) => ({
              AnswerID: index + 1,
              AnswerText: text.trim(),
              Order: index + 1
            }));
        }

        if (this.AnswersDto.length > 0 && this.AnswersDto[0].AnswerText.startsWith('Ordering Ordering')) {
          this.AnswersDto[0].AnswerText = this.AnswersDto[0].AnswerText.replace('Ordering Ordering', '').trim();
        } else if (this.AnswersDto.length > 0 && this.AnswersDto[0].AnswerText.startsWith('Ordering')) {
          this.AnswersDto[0].AnswerText = this.AnswersDto[0].AnswerText.replace('Ordering', '').trim();
        }
        
        this.selectedAnswer = this.AnswersDto.map((a: any) => a.AnswerID);
        this.AnswersDto = this.AnswersDto.sort(() => Math.random() - 0.5);
      });
    }
  }
  
  selectAnswer(answerID: number, questionType: string) {
    if (questionType === 'MultiAnswers') {
      if (this.selectedAnswers.includes(answerID)) {
        this.selectedAnswers = this.selectedAnswers.filter(id => id !== answerID);
      } else {
        this.selectedAnswers.push(answerID);
      }
    } else {
      this.selectedAnswer = this.selectedAnswer === answerID ? null : answerID;
    }  
    this.checkCorrectAnswer();
  }

  goToNextQuestion() {
    this.selectedAnswers = [];
    this.selectedAnswer = null;  
    this.qusetionScore = 0;

    if (this.currentQuestionIndex < this.totalQuestions - 1) {
      this.currentQuestionIndex++;
      this.loadQuestion(this.currentQuestionIndex);

      if(this.QuestionContent.IsSkipped || this.QuestionContent.IsPostponed) {
        this.remainingTimePerQuestion = 45;
      }else{
        this.remainingTimePerQuestion = 90; 
      }
  
      if (this.QuestionContent.QuestionType === 'MultiAnswers' && this.selectedAnswers.length > 1) {
        this.selectedAnswers = [];
      }
    } else {
      this.finishExam();
      this.getExamResult();
    }

    this.examService.submitStudentAnswer(this.submitQustion).subscribe();
      
    if (this.currentAudio) {
      this.currentAudio.pause();
      this.currentAudio = null;
    }
  
    this.isPlaying = false;
  }
  

  checkCorrectAnswer() {

    this.isCorrectAnswer();
    
    if (this.QuestionContent.QuestionType === 'MultiAnswers') {

      const correctAnswers = this.AnswersDto.filter(answer => answer.IsCorrect).map(answer => answer.AnswerID);
      let correctCount = 0;
  
      this.selectedAnswers.forEach(answerID => {
        if (correctAnswers.includes(answerID)) {
          correctCount++;
        }
      });
  
      this.submitQustion = {
        ExamAttendanceNo: this.examService.ExamAttendanceNo, 
        ExamID: this.ExamID,
        QuestionID: this.QuestionContent?.QuestionID ?? null, 
        IsSkipped: this.isSkipped, 
        IsPostponed: this.isPostponed, 
        IsAnswered: (this.selectedAnswers.length > 0) ? 1 : 0, 
        LanguageID: this.examService.LanguageID, 
        SelectedAnswerID: this.selectedAnswers.join(','),  
        IsCorrect: this.qusetionScore == 1 ? 1 : 0,
        Score: this.qusetionScore,
      };
  
    } else {
      this.submitQustion = {
        ExamAttendanceNo: this.examService.ExamAttendanceNo, 
        ExamID: this.ExamID,
        QuestionID: this.QuestionContent?.QuestionID ?? null, 
        IsSkipped: this.isSkipped, 
        IsPostponed: this.isPostponed, 
        IsAnswered: (this.selectedAnswer !== null || (this.selectedAnswers && this.selectedAnswers.length > 0)) ? 1 : 0, 
        LanguageID: this.examService.LanguageID, 
        SelectedAnswerID: this.selectedAnswer ?? this.selectedAnswers, 
        IsCorrect: this.qusetionScore == 1 ? 1 : 0,
        Score: this.qusetionScore,
      };
    }
  }
  

  isCorrectAnswer(): number {
    if (!this.QuestionContent || !this.AnswersDto) return 0;
  
    if (this.QuestionContent.QuestionType === 'MultiAnswers') {
      const correctAnswers = this.AnswersDto.filter(a => a.IsCorrect).map(a => a.AnswerID);
      const selectedCorrect = this.selectedAnswers.filter(ans => correctAnswers.includes(ans)).length;
      const totalCorrect = correctAnswers.length;
  
      if (this.selectedAnswers.length > totalCorrect) {
        this.qusetionScore = 0;
        return this.qusetionScore;
      }
  
      this.qusetionScore = totalCorrect > 0 ? selectedCorrect / totalCorrect : 0;
      return this.qusetionScore;
    } else {
      const correctAnswer = this.AnswersDto.find(a => a.IsCorrect)?.AnswerID;
      this.qusetionScore = this.selectedAnswer === correctAnswer ? 1 : 0;
      return this.qusetionScore;
    }
  }
  
  isCorrectOrderedAnswer() {

    if (this.AnswersDto.length == 0 && this.selectedAnswers.length > 1) {
      let correctStreak = 1;
      let maxStreak = 1;
  
      for (let i = 1; i < this.selectedAnswers.length; i++) {
        if (this.selectedAnswers[i].Order === this.selectedAnswers[i - 1].Order + 1) {
          correctStreak++;
          maxStreak = Math.max(maxStreak, correctStreak);
        } else {
          correctStreak = 1;
        }
      }
  
      const total = this.selectedAnswers.length;
      this.qusetionScore = maxStreak / total;
  
      this.submitQustion = {
        ExamAttendanceNo: this.examService.ExamAttendanceNo,  
        ExamID: this.ExamID,
        QuestionID: this.QuestionContent?.QuestionID ?? null, 
        IsSkipped: this.isSkipped, 
        IsPostponed: this.isPostponed, 
        IsAnswered: (this.selectedAnswer !== null || (this.selectedAnswers && this.selectedAnswers.length > 0)) ? 1 : 0, 
        LanguageID: this.examService.LanguageID, 
        SelectedAnswerID: this.selectOrderAnswerID, 
        IsCorrect: this.qusetionScore == 1 ? 1 : 0,
        Score: this.qusetionScore
      };

    } else {
      this.qusetionScore = 0;
    }
  }

  skipQuestion() {
    this.totalQuestions++;
  
    this.skipThisQuestion = {
      LanguageID: this.QuestionContent.LanguageID,
      QuestionID: this.QuestionContent.QuestionID,
      QuestionLevel: this.QuestionContent.QuestionLevel,
      QuestionType: this.QuestionContent.QuestionType,
      UnitID: this.QuestionContent.UnitID,
    };
  
    this.examService.questionSkip(this.skipThisQuestion).subscribe((response) => {
      const skippedQuestion = response.result[0][0];
      if (skippedQuestion) {
        skippedQuestion.IsSkipped = true;
        this.FormQuestions.push(skippedQuestion); 
  
        this.submitQustion = {
          ExamAttendanceNo: this.examService.ExamAttendanceNo, 
          ExamID: this.ExamID,
          QuestionID: this.QuestionContent?.QuestionID ?? null,
          IsSkipped: true,
          IsPostponed: false,
          IsAnswered: 0,
          LanguageID: this.examService.LanguageID,
          SelectedAnswerID: null,
          IsCorrect: 0,
          Score: 0,
        };
        
        if (this.skipCount > 0) {
          this.skipCount--;
          this.goToNextQuestion();
        }
      }
    });
  

  }
  
  postponeQuestion() {
    this.QuestionContent.IsPostponed = true;
    this.FormQuestions.push(this.QuestionContent);
    this.totalQuestions++;
    this.submitQustion = {
      ExamAttendanceNo: this.examService.ExamAttendanceNo, 
      ExamID: this.ExamID,
      QuestionID: this.QuestionContent.QuestionID,
      IsSkipped: false,
      IsPostponed: true,
      IsAnswered: 0,
      LanguageID: this.examService.LanguageID,
      SelectedAnswerID: null,
      IsCorrect: 0,
      Score: 0,
    };

    if (this.postponeCount > 0) {
      this.postponeCount--;
      this.goToNextQuestion();
    }
  }
  
  
  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.isCorrectOrderedAnswer();
  }  

  resetOrdering() {
    this.selectedAnswers = [];
    this.selectedAnswer = null;  
    this.loadQuestion(this.currentQuestionIndex);
  }
  
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${this.padZero(minutes)}:${this.padZero(remainingSeconds)}`;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }


  getExamResult() {
    this.examService.getExamResult(this.examService.ExamAttendanceNo).subscribe((response) => {
      if (response.success && response.result.length > 0) {
        const totalScore = response.result[0][0].TotalScore;
        
        this.examStutus = {
          AttemptID: this.AttemptID,
          Marks: totalScore,
          ExamResult: totalScore >= 80 ? 'Passed' : 'Failed',
          EndExamTime: new Date().toISOString(),
        };

        this.examResult = totalScore;
        

        this.examService.updateExamStatus(this.examStutus).subscribe((response) => {
          if (response.success) {
            this.examService.sendExamResultToTrainingApp(this.IDNumber, this.examStutus.ExamResult).subscribe(() => {});
          }
        });

        this.examService.sendTraineeResultToTrainingApp(this.bookingID, Number(this.IDNumber), this.examStutus.Marks).subscribe(() => {});
        
      }
    });
  }
  
  finishExam() {
    this.isExamCompleted = true;
    clearInterval(this.timerInterval);
    this.ngOnDestroy();
  }
  
  startTimer() {
    this.timerInterval = setInterval(() => {
      this.remainingTime--;
      this.remainingTimePerQuestion--;
      if (this.remainingTime <= 0) {
        this.finishExam();
      }

      if (this.remainingTimePerQuestion <= 0 && this.QuestionContent.QuestionType !== 'Ordering') {
        if(this.selectedAnswer == null && this.selectedAnswers.length == 0) {
          this.submitQustion = {
            ExamAttendanceNo: this.examService.ExamAttendanceNo,
            ExamID: this.ExamID,
            QuestionID: this.QuestionContent.QuestionID,
            IsSkipped: false,
            IsPostponed: false,
            IsAnswered: 0,
            LanguageID: this.examService.LanguageID,
            SelectedAnswerID: null,
            IsCorrect: this.qusetionScore == 1 ? 1 : 0,
            Score: this.qusetionScore,
          };
        }
        if(this.selectedAnswer || this.selectedAnswers.length > 0) {
          this.submitQustion = {
            ExamAttendanceNo: this.examService.ExamAttendanceNo,
            ExamID: this.ExamID,
            QuestionID: this.QuestionContent.QuestionID,
            IsSkipped: false,
            IsPostponed: false,
            IsAnswered: 1,
            LanguageID: this.examService.LanguageID,
            SelectedAnswerID: this.selectedAnswer || this.selectedAnswers.join(','),
            IsCorrect: this.qusetionScore == 1 ? 1 : 0,
            Score: this.qusetionScore,
          };
        }
        this.goToNextQuestion();
      }

      if (this.remainingTimePerQuestion <= 0 && this.QuestionContent.QuestionType === 'Ordering') {
        if(this.selectedAnswers.length == 0) {
          this.submitQustion = {
            ExamAttendanceNo: this.examService.ExamAttendanceNo,
            ExamID: this.ExamID,
            QuestionID: this.QuestionContent.QuestionID,
            IsSkipped: false,
            IsPostponed: false,
            IsAnswered: 0,
            LanguageID: this.examService.LanguageID,
            SelectedAnswerID: null,
            IsCorrect: this.qusetionScore == 1 ? 1 : 0,
            Score: this.qusetionScore,
          };
        }
        if(this.selectedAnswers.length > 0) {
          this.submitQustion = {
            ExamAttendanceNo: this.examService.ExamAttendanceNo,
            ExamID: this.ExamID,
            QuestionID: this.QuestionContent.QuestionID,
            IsSkipped: false,
            IsPostponed: false,
            IsAnswered: 1,
            LanguageID: this.examService.LanguageID,
            SelectedAnswerID: this.selectOrderAnswerID,
            IsCorrect: this.qusetionScore == 1 ? 1 : 0,
            Score: this.qusetionScore,
          };
        }
        this.goToNextQuestion();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }
  
  playAudio(text: string, language: string): void {
    if (this.isPlaying) return;
  
    if (Number(language)) {
      language = this.filteredLanguagesList.find((lang: any) => lang.LanguageID == language)?.LanguageName;
    }
  
    language = this.filteredLanguagesList.find((lang: any) => lang.LanguageName === language)?.ShortName;
  
    this.isPlaying = true;
  
    this.audioService.textToAudio(text, language).subscribe({
      next: (audioBlob: Blob) => {
        const audioSrc = URL.createObjectURL(audioBlob);
  
        if (this.currentAudio) {
          this.currentAudio.pause();
          this.currentAudio = null;
        }
  
        this.currentAudio = new Audio(audioSrc);
        this.currentAudio.play();
  
        this.currentAudio.onended = () => {
          this.isPlaying = false;
          this.currentAudio = null;
        };
      },
      error: () => {
        this.isPlaying = false;
      }
    });
  }

  restartExam(){
    this.router.navigate(['dashboard/exam']);
    this.examService.ExamAttendanceNo = null;
    this.examService.LanguageID = 0;
  }
}
